import { DeleteOutline, EscalatorWarning, Edit, Face5, Person, PersonAddAlt, PersonAddAlt1 } from "@mui/icons-material";
import TooltipComponent from "components/TooltipComponent";
import { t } from "i18next";
import { ReactNode } from "react";
import { IRecognitionTypeOption, IRecognitionTypes } from "services/Recognition/types";

export const getRecognitionTypeLabel = (
    type: IRecognitionTypes,
  ): React.ReactNode => {
    switch (type) {
      case IRecognitionTypes.GENERAL:
        return (
          <TooltipComponent title={t('recognitionPage.registerFace.general')}>
            <Person color={'primary'} />
          </TooltipComponent>
        );
      case IRecognitionTypes.CUSTOMER:
        return (
          <TooltipComponent title={t('recognitionPage.registerFace.customer')}>
            <PersonAddAlt color={'warning'} />
          </TooltipComponent>
        );
      case IRecognitionTypes.STUDENT:
        return (
          <TooltipComponent title={t('recognitionPage.registerFace.student')}>
            <Face5 color={'success'} />
          </TooltipComponent>
        );
      case IRecognitionTypes.RESPONSIBLE:
        return (
          <TooltipComponent
            title={t('recognitionPage.registerFace.responsible')}
          >
            <EscalatorWarning color={'secondary'} />
          </TooltipComponent>
        );
      default:
        return 'Desconhecido';
    }
  };

export const getRecognitionTypesOptions = (): IRecognitionTypeOption[] => [
    { label: t('recognitionPage.modalEditFace.typesOfResponsible.general'), value: IRecognitionTypes.GENERAL },
    { label: t('recognitionPage.modalEditFace.typesOfResponsible.customer'), value: IRecognitionTypes.CUSTOMER },
    { label: t('recognitionPage.modalEditFace.typesOfResponsible.student'), value: IRecognitionTypes.STUDENT },
    { label: t('recognitionPage.modalEditFace.typesOfResponsible.responsible'), value: IRecognitionTypes.RESPONSIBLE },
  ];

export type SyncOperationKind = 'create' | 'update' | 'delete';

export const getSyncOperationFromJobType = (jobType?: string | null): SyncOperationKind => {
  if (jobType?.includes('.delete_')) return 'delete';
  if (jobType?.includes('.update_')) return 'update';
  return 'create';
};

interface SyncOperationMeta {
  label: string;
  preparingMessage: string;
  doneMessage: string;
  icon: ReactNode;
  color: string;
}

export const SYNC_OPERATION_META: Record<SyncOperationKind, SyncOperationMeta> = {
  create: {
    label: 'Cadastro',
    preparingMessage: 'Salvando cadastro e enviando imagem...',
    doneMessage: 'Cadastro concluído!',
    icon: <PersonAddAlt1 />,
    color: 'primary.main',
  },
  update: {
    label: 'Atualização',
    preparingMessage: 'Salvando alterações...',
    doneMessage: 'Atualização concluída!',
    icon: <Edit />,
    color: 'info.main',
  },
  delete: {
    label: 'Exclusão',
    preparingMessage: 'Preparando exclusão...',
    doneMessage: 'Exclusão concluída!',
    icon: <DeleteOutline />,
    color: 'error.main',
  },
};